import { Box, Typography, Stack } from "@mui/material";
import { ReactNode } from "react";

interface Props {
  title: string;
  subtitle?: ReactNode;
  action?: ReactNode;
  eyebrow?: string;
}

export function PageHeader({ title, subtitle, action, eyebrow }: Props) {
  return (
    <Stack
      direction={{ xs: "column", sm: "row" }}
      alignItems={{ xs: "flex-start", sm: "flex-end" }}
      justifyContent="space-between"
      gap={2}
      sx={{ mt: 1 }}
    >
      <Box>
        {eyebrow && (
          <Typography variant="overline" sx={{ color: "text.secondary" }}>
            {eyebrow}
          </Typography>
        )}
        <Typography variant="h4" sx={{ color: "primary.dark" }}>{title}</Typography>
        {subtitle && (
          <Typography variant="body2" sx={{ color: "text.secondary", mt: 0.5 }}>
            {subtitle}
          </Typography>
        )}
      </Box>
      {action && <Box sx={{ width: { xs: "100%", sm: "auto" } }}>{action}</Box>}
    </Stack>
  );
}
